import React from "react";

import PageMetaData from "../../components/PageMetaData/PageMetaData.js";
import TitleMain from "../../components/TitleMain/TitleMain.js";

const Projects = () => {
  return (
    <>
      <PageMetaData title={"Projects | jBot"} />
      <TitleMain>Projects</TitleMain>
    </>
  );
};

export default Projects;
